export class CertificationsRequest{
    certificateId : number;
    
    constructor(certificateId : number)
    {
        this.certificateId = certificateId;
        
    }
}
